<div class="scrollableColumn">
	<ng-content select="[left]" />
</div>

<div class="scrollableColumn">
	<div class="scrollViewport">
		<ng-content select="[main]" />
	</div>
	<ng-content select="[mainCustomOverflow]" />
</div>

<div class="scrollableColumn">
	<ng-content select="[right]" />
</div>
